module.exports = __webpack_public_path__ + "img/analisis-clinico.21e1feaf.jpg";